import { initials } from "@/lib/format";
import { cx } from "@/lib/cx";

export function Avatar({
  name,
  src,
  size = "md",
  square,
  className,
}: {
  name: string;
  src?: string | null;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  square?: boolean;
  className?: string;
}) {
  const dims = { xs: "size-5 text-[9px]", sm: "size-6 text-[10px]", md: "size-8 text-xs", lg: "size-10 text-sm", xl: "size-16 text-lg" }[size];
  const shape = square ? "rounded-md" : "rounded-full";
  if (src) {
    // Square = logo: show the whole mark (any aspect ratio) on a light tile. Round = photo: fill and crop.
    const fit = square
      ? cx("bg-logo-tile object-contain", { xs: "p-px", sm: "p-px", md: "p-0.5", lg: "p-0.5", xl: "p-1" }[size])
      : "bg-surface object-cover";
    return <img src={src} alt="" className={cx(dims, shape, "shrink-0 border border-line", fit, className)} />;
  }
  return (
    <span aria-hidden className={cx(dims, shape, "inline-flex shrink-0 items-center justify-center bg-surface-sunken font-semibold text-fg-muted", className)}>
      {initials(name)}
    </span>
  );
}
